//   "use client";
// import { FiCheckCircle, FiCalendar, FiUserCheck } from "react-icons/fi";
// import styles from "../../../../assets/css/applicationTracker.module.css";
// import React, { JSX, use } from "react";

// interface ProgressStep {
//   id: string;
//   label: string;
//   icon: JSX.Element;
// }

// interface ProgressBarProps {
//   currentStatus: string;
// }

// const ProgressBar: React.FC<ProgressBarProps> = ({ currentStatus }) => {
//   const steps: ProgressStep[] = [
//     {
//       id: "applicationSubmitted",
//       label: "Application Submitted",
//       icon: <FiCheckCircle />
//     },
//     {
//       id: "underReview", 
//       label: "Under Review",
//       icon: <FiCheckCircle />
//     },
//     {
//       id: "visitScheduled",
//       label: "Visit Scheduled", 
//       icon: <FiCalendar />
//     },
//     {
//       id: "approved",
//       label: "Approved",
//       icon: <FiUserCheck />
//     },
//     {
//       id: "enrolled",
//       label: "Enrolled",
//       icon: <FiUserCheck />
//     }
//   ];

//   // Debug logging
//   console.log("ProgressBar - Current Status:", currentStatus);

//   const getStepStatus = (stepId: string): string => {
//     const stepIndex = steps.findIndex(step => step.id === stepId);
//     const currentIndex = steps.findIndex(step => step.id === currentStatus);
    
//     console.log(`Step: ${stepId}, StepIndex: ${stepIndex}, CurrentIndex: ${currentIndex}`);
    
   
//     if (currentIndex === -1) {
//       console.warn(`Current status "${currentStatus}" not found in progress steps`);
//       return "";
//     }
    
//     if (stepIndex < currentIndex) return styles.done;
//     if (stepIndex === currentIndex) return styles.active;
//     return "";
//   };

//   return (
//     <div className={styles.progressContainerWrapper}>
//       <h3 className={styles.progressHeading}>Application Progress</h3>
//      <div className={styles.progress}>
//        {steps.map((step, index) => (
//         <div 
//           key={step.id}
//           className={`${styles.step} ${getStepStatus(step.id)}`}
//         >
//           <div className={styles.icon} 
// >{step.icon}</div>
//           <span>{step.label}</span>
//         </div>
//       ))}
//      </div>
//     </div>
//   );
// };

// export default ProgressBar;


"use client";

import React from "react";
import { FiCheckCircle, FiCalendar, FiUserCheck } from "react-icons/fi";
import styles from "@/assets/css/applicationTracker.module.css";

type BarStatus =
  | "submitted"
  | "reviewed"
  | "visitScheduled"
  | "approved"
  | "enrolled"
  | "pending";

const STEPS: { key: Exclude<BarStatus, "pending">; label: string; Icon: React.ComponentType<any> }[] = [
  { key: "submitted",       label: "Application Submitted", Icon: FiCheckCircle },
  { key: "reviewed",        label: "Under Review",          Icon: FiCheckCircle },
  { key: "visitScheduled",  label: "Visit Scheduled",       Icon: FiCalendar    },
  { key: "approved",        label: "Decision Made",         Icon: FiUserCheck   },
  { key: "enrolled",        label: "Admitted",              Icon: FiUserCheck   },
];

function idxFor(status: BarStatus) {
  const i = STEPS.findIndex(s => s.key === status);
  return i < 0 ? -1 : i;
}

export default function ProgressBar({ currentStatus }: { currentStatus: BarStatus }) {
  const activeIdx = idxFor(currentStatus);

  return (
    <div className={styles.progress}>
      {STEPS.map((s, i) => {
        const stateClass =
          activeIdx === -1
            ? "" // pending / unknown
            : i < activeIdx
            ? styles.done
            : i === activeIdx
            ? styles.active
            : "";

        const Icon = s.Icon;

        return (
          <div key={s.key} className={`${styles.step} ${stateClass}`}>
            <Icon className={styles.icon} />
            <span>{s.label}</span>
          </div>
        );
      })}
    </div>
  );
}
